<template>
  <div class="overflow-hidden bg-white p-3">
    <div class="flex flex-row gap-2 bg-blue-500">
         <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">ERN</label>
      <input
        v-model="ernFilter"
        type="text"
        @keyup.enter="fetch"
        placeholder="Registration Number"
        class="w-full px-3 py-2 border border-gray-300 rounded text-xs focus:ring-2 focus:ring-primary focus:border-primary"
      />
      </div>
      
         <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Name</label>
      <input
        v-model="nameFilter"
        type="text"
        @keyup.enter="fetch"
        placeholder="Search name..."
        class="w-full px-3 py-2 border border-gray-300 rounded text-xs focus:ring-2 focus:ring-primary focus:border-primary"
      />
      </div>

   <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Entity Type</label>
      <select
        v-model="entityTypeFilter"
        @change="onEntityTypeChange"
        required
        class="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-primary focus:border-primary"
      >
        <option value="">Select Entity Type</option>
        <option v-for="(type, idx) in primaryEntityTypes" :key="idx" :value="type.id">
          {{ type.name }}
        </option>
      </select>
      </div>

   <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Sub Entity Type</label>
      <select
        v-model="subEntityTypeFilter"
        required
        @change="fetch"
        class="w-full px-3 py-2 border border-gray-300 rounded text-xs focus:ring-2 focus:ring-primary focus:border-primary"
      >
        <option value="">Select Sub Entity Type</option>
        <option v-for="(type, idx) in subEntityTypes" :key="idx" :value="type.id">
          {{ type.name }}
        </option>
      </select>
      </div>

      <!-- Institution -->
      <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Associate Register</label>
        <select
          v-model="institutionId"
          class="w-full border border-gray-300 rounded px-3 py-2 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
          @change="fetch"
        >
          <option :value="null">-- Filter by Associate Register --</option>
          <option
            v-for="inst in institutions"
            :key="inst.id"
            :value="inst.id"
          >
            {{ inst.name }}
          </option>
        </select>
      </div>

    </div>
    <div class="mx-auto">
      <b-progress value="100" v-if="loading"  variant="#007ac5" height="0.2rem" animated></b-progress>
    </div>

    <div class="bg-white shadow overflow-hidden mt-2 flex flex-col">
      <div class="overflow-x-auto flex-1">
        <table class="w-full text-xs">
          <thead class="bg-gray-50 border-b border-gray-100 sticky top-0">
            <tr>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">#</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">ERN</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">Name</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">Type</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">Sub Type</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">Associate Register</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">Status</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">Record Status</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">Compliance Status</th>
              <th class="text-left py-3 px-4 font-semibold text-gray-700">Actions</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="entities && entities.length > 0">
              <tr
                v-for="(item, idx) in entities"
                :key="idx"
                class="border-b border-gray-100 hover:bg-gray-50 transition"
              >
                <td class="py-3 px-4 font-bold">
                  <span>{{ (page - 1) * limit + idx + 1 }}</span>
                </td>
                <td class="py-3 px-4 font-bold text-blue">
                  <span class="cursor-pointer hover:underline hover:text-blue-dark" @click="view(item.ern)">{{ item.ern }}</span>
                </td>
                <td class="py-3 px-4">
                  {{ item.name ? item.name.toUpperCase() : "" }}
                </td>
                <td class="py-3 px-4">
                  <span>{{ item.type }}</span>
                </td>
                <td class="py-3 px-4">
                  <span v-if="item.subType">{{ item.subType }}</span>
                  <span v-else>--</span>
                </td>
                <td class="py-3 px-4">
                  <div class="flex gap-2 text-blue">
                    <i class="fas fa-bank my-auto"></i>
                    <span class="my-auto">{{ item.registrationInstitution }}</span>
                  </div>
                </td>
                <td class="py-3 px-4">
                  <span
                    class="text-[10px] font-semibold px-2.5 py-0.5 rounded-full inline-block"
                    :class="getStatusColor(item.status)"
                  >
                    {{ item.status }}
                  </span>
                </td>

                <td class="py-3 px-4">
                  <span
                    class="text-[10px] font-semibold px-2.5 py-0.5 rounded-full inline-block"
                    :class="getRecordStatusColor(item.recordStatus)"
                  >
                    {{ cleanUnderscores(item.recordStatus) }}
                  </span>
                </td>

                 <td >
                  <b-badge
                      :class="item.complianceStatus === 'NON_COMPLIANT' ? 'bg-red' : 'bg-green'"
                      class="text-capitalize px-2 py-1"
                  >
                    {{ cleanUnderscores(item.complianceStatus) }}
                  </b-badge>
                </td>
                <td>
                  <button
                  type="button"
                    @click="view(item.ern)"
                    class="bg-blue  text-white px-2 py-1 rounded text-xs"
                    title="View Details"
                  >
    
                    View File
                  </button>
                </td>
              </tr>
            </template>

            <template v-if="!entities || (entities && entities.length === 0)">
              <tr>
                <td colspan="8" class="py-16 text-center">
                  <div class="flex flex-col items-center justify-center text-gray-400">
                    <i class="fa fa-folder-open text-6xl mb-4"></i>
                    <p class="text-lg font-medium text-gray-500">No Entities Found</p>
                    <p class="text-sm text-gray-400 mt-2">
                      There are no registered entities in the registry yet.
                    </p>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div
        class="mt-2 flex flex-wrap items-center justify-between"
        v-if="pagination && pagination.totalPages > 1"
      >
        <div class="flex items-center gap-2">
          <button @click="previous" :class="(page > 1) ? 'paginate-btn' : 'inert-btn'">
            Previous
          </button>
          <div class="paginate-details text-center">
            <span class="bg-blue text-white px-2 py-1 rounded-sm text-xs">
              {{ page }}/{{ pagination.totalPages }}
            </span>
          </div>
          <button @click="next" :class="(page < pagination.totalPages) ? 'paginate-btn' : 'inert-btn'">
            Next
          </button>
        </div>

        <div class="flex items-center gap-3">
          <select
            v-model.number="limit"
            class="w-20 text-xs form-select border-0 paginate-details"
            @change="fetch"
          >
            <option :value="15">15</option>
            <option :value="20">20</option>
            <option :value="50">50</option>
            <option :value="100">100</option>
          </select>
          <p class="paginate-details text-center text-xs font-bold whitespace-nowrap">
            <span>{{ ((page - 1) * limit) + 1 }}</span> -
            <span v-if="limit > entities.length ">{{ pagination.totalElements }}</span>
            <span v-else>{{ page * limit }}</span>
            of {{ pagination.totalElements }}
          </p>
        </div>
    </div>
  </div>
</div>
</template>

<script>


import {api} from "../../../../../app/services/api.service";

export default {
  name: "NIRRegistry",
  data() {
    return {
      loading: false,
      page: 1,
      limit: 15,
      entities: [],
      pagination: {
        totalElements: 0,
        totalPages: 0,
      },
      selectedErn: "",
      nameFilter: "",
      ernFilter: "",
      entityTypeFilter: "",
      subEntityTypeFilter: "",
      primaryEntityTypes: [],
      subEntityTypes: [],
      institutions: [],
      institutionId: null,

    };
  },
  created() {
    this.loadInitial();
  },
  methods: {
    async loadInitial() {
      this.loading = true;
      try {
        await api().get("/nir/api/v1/institutions?page=1&limit=1000");
      } catch (e) {
        console.error("Failed to load institutions", e);
      }

      try {
        await this.fetchPrimaryEntityTypes();
      } catch (e) {
        console.error("Failed to load primary entity types", e);
      }

      await this.fetch();
      this.loading = false;
    },
    async fetchPrimaryEntityTypes() {
      const response = await api().get("/nir/api/v1/configurations/entity-types/primary");
      if (response && response.data && response.data.data && response.data.data.data) {
        this.primaryEntityTypes = response.data.data.data;
      } else {
        this.primaryEntityTypes = [];
      }
    },
    async fetchSubTypes() {
      if (!this.entityTypeFilter) {
        this.subEntityTypes = [];
        return;
      }
      let path = "/v1/configurations/entity-types?parentId=" + this.entityTypeFilter;
      const response = await api().get("/nir/api/" + path);
      if (response && response.data && response.data.data && response.data.data.data) {
        this.subEntityTypes = response.data.data.data;
      } else {
        this.subEntityTypes = [];
      }
    },
    onEntityTypeChange() {
      this.fetchSubTypes();
      this.fetch();
    },
    async fetch() {
      this.loading = true;
      let path = "/v1/registry?page=" + this.page + "&limit=" + this.limit
      // Filters (name, ern, entityType, subType) can be added here when backend supports them
      //+"&name="+this.nameFilter+"&ern="+this.ernFilter+"&typeId="+this.entityTypeFilter+"&subTypeId="+this.subEntityTypeFilter;
      if(this.nameFilter){
        path += "&name="+this.nameFilter;
      }
      if(this.ernFilter){
        path += "&ern="+this.ernFilter;
      }
      if(this.entityTypeFilter){
        path += "&typeId="+this.entityTypeFilter;
      }
      if(this.subEntityTypeFilter){
        path += "&subTypeId="+this.subEntityTypeFilter;
      }
      if(this.institutionId){
        path += "&institutionId="+this.institutionId;
      }
      try {
        const response = await api().get("/nir/api/" + path);
        if (response && response.data && response.data.data) {
          const data = response.data.data;
          this.entities = data.content || [];
          const pag = data.pagination || {};
          this.pagination = {
            totalPages: pag.totalPages || 0,
            totalElements: pag.totalRows || 0,
          };
          if (typeof pag.currentPage === "number") {
            this.page = pag.currentPage;
          }
          this.$emit("loaded", this.pagination.totalElements);
        } else {
          this.entities = [];
          this.pagination = { totalPages: 0, totalElements: 0 };
          this.$emit("loaded", 0);
        }
      } catch (error) {
        console.error("Failed to load registry entities", error);
        this.entities = [];
        this.pagination = { totalPages: 0, totalElements: 0 };
        this.$emit("loaded", 0);
      } finally {
        this.loading = false;
      }
    },
        fetchInstitutions() {
      api().get('/nir/api/v1/institutions?page=1&limit=1000')
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.content) {
              this.institutions = res.data.data.content;
            } else {
              this.institutions = [];
            }
          })
          .catch(function () {
            this.institutions = [];
          });
    },
    view(ern) {
      if (!ern) return;
      this.$router.push({ path: '/home/registry/nir-entity-view', query: { ern: ern } });
    },
    getStatusColor(status) {
      if (!status) return "text-gray-700 bg-gray-100";
      const s = status.toUpperCase().replace(/[\s_-]+/g, "");
      if (s === "REGISTERED") {
        return "text-green-700 font-bold bg-green-100";
      } else if (s === "DISSOLVED" || s === "DEREGISTERED") {
        return "text-red-700 bg-red-100";
      }
      return "text-gray-700 bg-gray-100";
    },
    getRecordStatusColor(status) {
      if (!status) return "text-gray-700 bg-gray-100";
      const normalized = status.toUpperCase().replace(/[\s_]+/g, "");
      if (normalized === "COMPLETED" || normalized === "COMPLETE") {
        return "text-blue-800 bg-blue-100";
      }
      return "text-amber-800 bg-amber-100";
    },
    next() {
      if (this.page < this.pagination.totalPages) {
        this.page += 1;
        this.fetch();
      }
    },
    previous() {
      if (this.page > 1) {
        this.page -= 1;
        this.fetch();
      }
    },
    update(pg) {
      this.page = pg;
      this.fetch();
    },
  },
};
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.text-blue-800 {
  color: #1e40af;
}

.bg-amber-100 {
  background-color: #fef3c7;
}

.text-amber-800 {
  color: #92400e;
}

.text-\[10px\] {
  font-size: 10px;
  line-height: 14px;
}
</style>

